export const ACTIVITY_STATUSES = {
    UNKNOWN: -1,
    INACTIVE: 0,
    ACTIVE: 1,
    DELETED: 2,
} as const;

export const StudyStatuses = {
    None: 'None',
    Finished: 'Finished',
    Ongoing: 'Ongoing',
    Upcoming: 'Upcoming',
} as const;

export const SESSION_STATUS_ID = {
    UNKNOWN: 0,
    COMPLETED: 1,
    CANCELED: 2,
    EXPIRED: 3,
    BLOCKED: 4,
    INVALID_CRITERIA: 5,
    IN_PROGRESS: 6,
};

export const ACTIVITY_TYPES = {
    SURVEY: 'survey',
    TIME_USE: 'time_use',
    PAGE: 'page',
    // 'web' type includes: Wheel of Fortune, Summary Page, Time Pref, Stroop, Matrix Reasoning, Progress Reward, My Progress.
    WEB: 'web',
};

export const ACTIVITY_CATEGORIES = {
    SURVEY: 'survey',
    WEB: 'web',
    TIME_USE: 'timeUse',
    PAGE: 'page',
    UNKNOWN: 'unknown',
};

export const STUDY_STATUSES = {
    UNKNOWN: 'UNKNOWN',
    FINISHED: 'FINISHED',
    ONGOING: 'ONGOING',
    UPCOMING: 'UPCOMING',
};

export const TRIGGERING_LOGIC_TYPE_NAMES = {
    UNKNOWN: '',
    RESEARCHER: 'researcher',
    ELIGIBILITY: 'eligibility',
    TIME: 'time',
    PROXIMITY: 'proximity',
    USER: 'user',
    DROPOUT: 'dropout',
    TIME_USER_DEF: 'time_user_def',
} as const;

export const TRIGGERING_LOGIC_TYPE_IDS = {
    UNKNOWN: -1,
    RESEARCHER: 0,
    ELIGIBILITY: 1,
    TIME: 2,
    PROXIMITY: 3,
    USER: 4,
    DROPOUT: 5,
    TIME_USER_DEF: 6,
} as const;

export const TRIGGERING_LOGIC_IDS = {
    INVALID_TL_ID: -2,
    RESEARCHER_TRIGGERED_TL_ID: -1,
};

export const SURVEY_TYPES = {
    UNKNOWN: -1,
    GENERIC: 0,
    TIME_USE: 1,
};

export const ELIGIBILITY_STATUSES = {
    UNKNOWN: 'UNKNOWN',
    ELIGIBLE: 'ELIGIBLE',
    NOT_ELIGIBLE: 'NOT_ELIGIBLE',
};

export const ACTIVITY_CATEGORIES_DEFAULT_ICON = {
    [ACTIVITY_CATEGORIES.SURVEY]: '\uf733',
    [ACTIVITY_CATEGORIES.WEB]: '\uf2d2',
    [ACTIVITY_CATEGORIES.TIME_USE]: '\uf073',
    [ACTIVITY_CATEGORIES.PAGE]: '\uf02c',
    [ACTIVITY_CATEGORIES.UNKNOWN]: '\uf2d2', // using the web category icon
};
